import React, { useContext } from 'react';

import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import { getMenuAdminConfiguration } from '@totem/components/ui_components/menus/mainMenu/admin_configuration';
import TabContentMenu from '@totem/components/ui_components/menus/tabContentMenu';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';

const ConfigurationManagementPage = () => {
  const { userProfile } = useContext(UserProfileContext);

  return (
    <ContentLayout>
      <IBCard>
        <TabContentMenu items={getMenuAdminConfiguration(userProfile)} />
      </IBCard>
    </ContentLayout>
  );
};

export default ConfigurationManagementPage;
